import { useMemo } from 'react';
import ACContentBreakdownList from 'academy-common-lib/components/list/ACContentBreakdownList';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentOverview = ({
  content,
  hasCertificate,
  hasStudyGuide
}) => {
  const videos = useMemo(() => (content || []).filter(c => c.contentType === 'VIDEO').length, [content]);
  const quizzes = useMemo(() => (content || []).filter(c => c.contentType === 'QUIZ').length, [content]);
  const practicalExercises = useMemo(() => (content || []).filter(c => c.contentType === 'PRACTICAL_EXERCISE_FLOW').length, [content]);
  const links = useMemo(() => (content || []).filter(c => c.contentType === 'LINK').length, [content]);
  return /*#__PURE__*/_jsx(ACContentBreakdownList, {
    certificateCount: hasCertificate ? 1 : 0,
    exerciseCount: practicalExercises,
    quizCount: quizzes,
    resourceCount: links + (hasStudyGuide ? 1 : 0),
    videoCount: videos
  });
};
export default ContentOverview;